import BaseModelFactory from './base.factory'
import AgentPackageService from './../services/AgentPackage.service'
import AgentPackage from './../models/agent-package.model'

class AgentPackageFactory extends BaseModelFactory {
  static search = async ({ search, pagination, order_by, method }) =>
    await this._search({ search, pagination, order_by, method }, { Service: AgentPackageService, Model: AgentPackage })
  static findById = async id => await this._findBy({ id: id }, { Service: AgentPackageService, Model: AgentPackage })
  static create = payload =>
    this._create(payload, {
      Service: AgentPackageService,
      Model: AgentPackage,
    })
}

export default AgentPackageFactory
